import React from "react";
import PropTypes from "prop-types";
// import cx from "classnames";
// import { Map } from "immutable";
import { Form } from "antd";
import { fieldGenerator, getErrorOnField, submitForm } from "utilities/form";
import { UNDERWRITING_JOB_FIELDS } from "constants/form-fields";
import { UnderwritingService } from "services";
import "styles/form.css";

class AddUnderwritingJobForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(this.props.form, values =>
        this.props.onFormSubmit(values)
    );
    setGstin = company => {
        this.props.form.setFieldsValue({
            gstin: company
        });
    };
    enhanceFormFields() {
        return UNDERWRITING_JOB_FIELDS.set("distributor", {
            ...UNDERWRITING_JOB_FIELDS.get("distributor"),
            labelProp: "distributor_name",
            showSearch: true,
            onSearch: (str) => UnderwritingService.getDistributorsList(str),
            formatData: (data) => {
                if(data) {
                    return data.map(_ => {
                        return {
                            ..._,
                            distributor_name: `${_.distributor_name} (${_.company_code})`
                        };
                    });
                }
                return data;
            },
            onSelect: this.setGstin
        });
    }

    fields = this.enhanceFormFields();
    render() {
        return (
            <Form
                layout="horizontal"
                hideRequireMark={false}
                className={"form d-flex"}
                onSubmit={this.handleFormSubmit}
            >
                <div className={"form-row align-items-center"}>
                    {this.fields
                        .map((field, fieldName) =>
                            this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )()
                        )
                        .toList()}
                </div>
            </Form>
        );
    }
}

AddUnderwritingJobForm.propTypes = {
    values: PropTypes.object,
    form: PropTypes.object,
    onFormSubmit: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values }) =>
        values &&
        values
            .map(value =>
                Form.createFormField({
                    value
                })
            )
            .toJS()
})(AddUnderwritingJobForm);
